import { TextInput, TextInputProps } from "@mantine/core";

/**
 * TextInput, который пропускает в onChange только цифры.
 * Все нецифровые символы (буквы, пробелы, точки, дефисы) вырезаются.
 *
 * Используется для банковских реквизитов (БИК — 9 цифр, расчётный счёт — 20),
 * номеров паспорта/ВУ, ОГРН/ИНН и т.п. — там где «защита от дурака» нужна.
 *
 * Ограничение длины — через `maxLength`. Если в input пришёл paste с
 * посторонними символами, они удаляются, а остающиеся цифры обрезаются
 * до maxLength.
 */
export interface DigitsOnlyInputProps
  extends Omit<TextInputProps, "value" | "onChange"> {
  value?: string;
  onChange?: (digits: string) => void;
  /** Максимум цифр (после очистки). По умолчанию 20 (длина р/счёта). */
  maxLength?: number;
}

export function DigitsOnlyInput({
  value = "",
  onChange,
  maxLength = 20,
  inputMode = "numeric",
  ...rest
}: DigitsOnlyInputProps) {
  return (
    <TextInput
      {...rest}
      value={value}
      onChange={(e) => {
        const cleaned = e.currentTarget.value.replace(/\D+/g, "").slice(0, maxLength);
        onChange?.(cleaned);
      }}
      inputMode={inputMode}
      autoComplete="off"
    />
  );
}
